/* BZ · Réplica Reliva — carrossel de depoimentos do bloco de compra */
(function () {
  "use strict";
  function init() {
    document.querySelectorAll("[data-bz-rv-slider]:not([data-ready])").forEach(function (el) {
      el.setAttribute("data-ready", "1");
      var track = el.querySelector(".bz-rvm-rv__track"), dots = el.querySelector(".bz-rvm-rv__dots");
      var n = track ? track.children.length : 0, i = 0, timer = null;
      if (n < 2) return;
      for (var k = 0; k < n; k++) dots.appendChild(document.createElement("i"));
      function go(x) { i = (x + n) % n; track.style.transform = "translateX(" + (-100 * i) + "%)"; [].forEach.call(dots.children, function (d, j) { d.classList.toggle("is-on", j === i); }); }
      function play() { stop(); timer = setInterval(function () { go(i + 1); }, 3500); }
      function stop() { if (timer) clearInterval(timer); }
      var sx = null;
      el.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
      el.addEventListener("touchend", function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 30) go(i + (dx < 0 ? 1 : -1)); sx = null; play(); }, { passive: true });
      go(0); play();
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
